module.exports = __webpack_public_path__ + "static/media/Door.88d0c222.mp3";